import { render, staticRenderFns } from "./AppItemsSelector.vue?vue&type=template&id=f944f962&scoped=true&"
import script from "./AppItemsSelector.vue?vue&type=script&lang=js&"
export * from "./AppItemsSelector.vue?vue&type=script&lang=js&"
import style0 from "./AppItemsSelector.vue?vue&type=style&index=0&id=f944f962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f944f962",
  null
  
)

export default component.exports